import {
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILURE,
  GET_USER_DATA_SUCCESS,
  GET_USER_DATA_FAILURE,
  INCREMENT_STEP,
  INCREMENT_STEP_SUCCESS,
  INCREMENT_STEP_FAILURE,
  GET_REASONS_SUCCESS,
  GET_REASONS_FAILURE,
  CHOOSE_REASONS_SUCCESS,
  CHOOSE_REASONS_FAILURE,
  SET_DETAILS_SUCCESS,
  SET_DETAILS_FAILURE,
  SET_ABOUT_SUCCESS,
  SET_ABOUT_FAILURE,
  GET_INTERESTS_SUCCESS,
  GET_INTERESTS_FAILURE,
  CHOOSE_INTERESTS_SUCCESS,
  CHOOSE_INTERESTS_FAILURE,
  GET_AGE_SUCCESS,
  GET_AGE_FAILURE,
  CHOOSE_AGE_SUCCESS,
  CHOOSE_AGE_FAILURE,
  GET_DIVERSITY_SUCCESS,
  GET_DIVERSITY_FAILURE,
  CHOOSE_DIVERSITY_SUCCESS,
  CHOOSE_DIVERSITY_FAILURE,
  GET_MEMBERSHIPS_SUCCESS,
  GET_MEMBERSHIPS_FAILURE,
  CHOOSE_MEMBERSHIP_SUCCESS,
  CHOOSE_MEMBERSHIP_FAILURE,
  GET_CREDIT_CARD_SUCCESS,
  GET_CREDIT_CARD_FAILURE,
  SET_CREDIT_CARD_SUCCESS,
  SET_CREDIT_CARD_FAILURE,
  DELETE_CREDIT_CARD_SUCCESS,
  DELETE_CREDIT_CARD_FAILURE,
  GET_BILLING_ADDRESS_SUCCESS,
  GET_BILLING_ADDRESS_FAILURE,
  SET_BILLING_ADDRESS_SUCCESS,
  SET_BILLING_ADDRESS_FAILURE,
  GET_TERMS_AND_CONDITIONS_SUCCESS,
  GET_TERMS_AND_CONDITIONS_FAILURE,
  ACCEPT_TERMS_AND_CONDITIONS_SUCCESS,
  ACCEPT_TERMS_AND_CONDITIONS_FAILURE,
  RESEND_VERIFICATION_MESSAGE_SUCCESS,
  RESEND_VERIFICATION_MESSAGE_FAILURE,
  DELETE_DATA,
} from "features/application/form/redux/types";

const formReducer = (
  state = { responseCodes: {}, errorCodes: {}, errorFields: {} },
  action
) => {
  switch (action.type) {
    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        settings: action.payload,
      };
    case GET_SETTINGS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { settings: action.payload },
      };
    case GET_USER_DATA_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        userData: action.payload,
      };
    case GET_USER_DATA_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { userData: action.payload },
      };
    case INCREMENT_STEP:
      return {
        ...state,
        userData: { ...state.userData, current_step: action.payload },
      };
    case INCREMENT_STEP_SUCCESS:
      return {
        ...state,
        responseCodes: { incrementStep: action.payload },
        errorCodes: {},
      };
    case INCREMENT_STEP_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { incrementStep: action.payload },
      };
    case GET_REASONS_SUCCESS:
      fbq("track", "Subscribe"); // eslint-disable-line
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        reasons: action.payload,
      };
    case GET_REASONS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { reasons: action.payload },
      };
    case CHOOSE_REASONS_SUCCESS:
      fbq("track", "StartTrial"); // eslint-disable-line
      return {
        ...state,
        responseCodes: { ...state.responseCodes, reasons: action.payload },
        errorCodes: {},
      };
    case CHOOSE_REASONS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { reasons: action.payload },
      };
    case SET_DETAILS_SUCCESS:
      return {
        ...state,
        responseCodes: { details: action.payload },
        errorCodes: {},
      };
    case SET_DETAILS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { details: action.payload.status },
        errorFields: action.payload.data.errors,
      };
    case SET_ABOUT_SUCCESS:
      return {
        ...state,
        responseCodes: { about: action.payload },
        errorCodes: {},
      };
    case SET_ABOUT_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { about: action.payload.status },
        errorFields: action.payload.data.errors,
      };
    case GET_INTERESTS_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        interests: action.payload,
      };
    case GET_INTERESTS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { interests: action.payload },
      };
    case CHOOSE_INTERESTS_SUCCESS:
      return {
        ...state,
        responseCodes: { ...state.responseCodes, interests: action.payload },
        errorCodes: {},
      };
    case CHOOSE_INTERESTS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { interests: action.payload },
      };
    case GET_AGE_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        age: action.payload,
      };
    case GET_AGE_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { age: action.payload },
      };
    case CHOOSE_AGE_SUCCESS:
      return {
        ...state,
        responseCodes: { ...state.responseCodes, age: action.payload },
        errorCodes: {},
      };
    case CHOOSE_AGE_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { age: action.payload },
      };
    case GET_DIVERSITY_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        diversity: action.payload,
      };
    case GET_DIVERSITY_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { diversity: action.payload },
      };
    case CHOOSE_DIVERSITY_SUCCESS:
      return {
        ...state,
        responseCodes: { ...state.responseCodes, diversity: action.payload },
        errorCodes: {},
      };
    case CHOOSE_DIVERSITY_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { diversity: action.payload },
      };
    case GET_MEMBERSHIPS_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        memberships: action.payload,
      };
    case GET_MEMBERSHIPS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { memberships: action.payload },
      };
    case CHOOSE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        responseCodes: { memberships: action.payload },
        errorCodes: {},
      };
    case CHOOSE_MEMBERSHIP_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { memberships: action.payload },
      };
    case GET_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        creditCard: action.payload,
      };
    case GET_CREDIT_CARD_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { creditCard: action.payload },
      };
    case SET_CREDIT_CARD_SUCCESS:
      fbq("track", "AddPaymentInfo"); // eslint-disable-line
      return {
        ...state,
        responseCodes: { creditCard: action.payload },
        errorCodes: {},
      };
    case SET_CREDIT_CARD_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { creditCard: action.payload.status },
        errorFields: action.payload.data.errors,
      };
    case DELETE_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        responseCodes: { deletion: action.payload },
        errorCodes: {},
        billingAddress: {},
      };
    case DELETE_CREDIT_CARD_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { deletion: action.payload },
      };
    case GET_BILLING_ADDRESS_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        billingAddress: action.payload,
      };
    case GET_BILLING_ADDRESS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { billingAddress: action.payload },
      };
    case SET_BILLING_ADDRESS_SUCCESS:
      fbq("track", "AddPaymentInfo"); // eslint-disable-line
      return {
        ...state,
        responseCodes: { billingAddress: action.payload },
        errorCodes: {},
      };
    case SET_BILLING_ADDRESS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { billingAddress: action.payload.status },
        errorFields: action.payload.data.errors,
      };
    case GET_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        termsAndConditions: action.payload,
      };
    case GET_TERMS_AND_CONDITIONS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { termsAndConditions: action.payload },
      };
    case ACCEPT_TERMS_AND_CONDITIONS_SUCCESS:
      fbq("track", "SubmitApplication"); // eslint-disable-line
      return {
        ...state,
        responseCodes: { termsAndConditions: action.payload },
        errorCodes: {},
      };
    case ACCEPT_TERMS_AND_CONDITIONS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { termsAndConditions: action.payload },
      };
    case RESEND_VERIFICATION_MESSAGE_SUCCESS:
      return {
        ...state,
        responseCodes: { verificationMessage: action.payload },
        errorCodes: {},
      };
    case RESEND_VERIFICATION_MESSAGE_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { verificationMessage: action.payload },
      };
    case DELETE_DATA:
      return {
        responseCodes: { ...state.responseCodes },
        errorCodes: { ...state.errorCodes },
      };
    default:
      return state;
  }
};

export default formReducer;
